import React from 'react';
import { Filter, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

const FILTER_LABELS = {
  'missing-evidence': { label: 'Missing Evidence', desc: 'Questions where Evidence Required = Yes but no file uploaded yet', tone: 'amber' },
  'pending': { label: 'Pending Submissions', desc: 'Questions you have not yet answered', tone: 'sky' },
  'overdue': { label: 'Overdue Actions', desc: 'Items with Expected Completion Date in the past', tone: 'orange' },
  'high-risk': { label: 'High & Critical Risk', desc: 'Risks scored High or Critical in the live master', tone: 'red' },
  'no-or-na': { label: 'No / N/A Responses', desc: 'Questions answered No or N/A — needing follow-up', tone: 'red' },
};

const TONE = {
  amber: 'bg-amber-50 border-amber-200 text-amber-900',
  sky: 'bg-sky-50 border-sky-200 text-sky-900',
  orange: 'bg-orange-50 border-orange-200 text-orange-900',
  red: 'bg-red-50 border-red-200 text-[#CC0000]',
};

export default function FilterBanner({ activeFilter, count, totalCount, onClear }) {
  const navigate = useNavigate();
  const location = useLocation();
  const cfg = FILTER_LABELS[activeFilter];
  if (!cfg) return null;

  const handleClear = () => {
    if (onClear) onClear();
    else navigate(location.pathname, { replace: true });
  };

  return (
    <div
      className={cn('flex items-center gap-3 px-4 py-3 rounded-xl border', TONE[cfg.tone])}
      data-testid="filter-banner"
    >
      <div className="w-8 h-8 rounded-lg bg-white/60 flex items-center justify-center flex-shrink-0">
        <Filter className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs font-bold flex items-center gap-2 flex-wrap">
          Filter active: <span className="px-2 py-0.5 rounded bg-white/70 font-mono">{cfg.label}</span>
          <span className="font-normal opacity-75">— showing {count} of {totalCount}</span>
        </div>
        <div className="text-[11px] opacity-80 mt-0.5">{cfg.desc} · landed here from the Dashboard.</div>
      </div>
      <button
        onClick={handleClear}
        className="inline-flex items-center gap-1 px-3 py-1.5 bg-white hover:bg-white/80 border border-current/20 text-xs font-semibold rounded-md transition flex-shrink-0"
        data-testid="clear-filter-btn"
      >
        <X className="w-3 h-3" />
        Clear filter
      </button>
    </div>
  );
}
